// webapp/src/components/RouteSkeleton.tsx
//
// Phase 31.6 Plan 02 — D-04 / FE-31-15.
// Single shared Suspense fallback for route-level React.lazy chunks.
//
// CLS-safe (RESEARCH Pitfall 3): a fixed min-height reserves the content area so
// a lazy-chunk swap does not shift layout. Uses min-h-[60vh] (not min-h-screen)
// so the SAME skeleton works both at the root AND nested inside AdminLayout's
// content area without over-pushing the admin sidebar/topbar chrome
// (Gemini Gate 1 finding #2 — reused root + nested per D-04).
//
// aria-hidden: it is a transient loading placeholder, not meaningful content.
//
// Refs: phase 31.6

export default function RouteSkeleton() {
  return (
    <div
      className="min-h-[60vh] bg-bg flex items-center justify-center"
      aria-hidden="true"
    >
      <div className="w-8 h-8 rounded-full bg-accent/30 animate-pulse" />
    </div>
  )
}
